import { Button, Card, Checkbox, List, Typography } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const { Title, Text, Paragraph } = Typography;

type MetaAccountSafetyProps = {
	onNext: () => void;
};

export const MetaAccountSafety: React.FC<MetaAccountSafetyProps> = ({ onNext }) => {
	const [isChecked, setIsChecked] = useState(false);

	return (
		<Card className="mt-2">
			<Typography>
				<Title level={4}>
					<FormattedMessage id="help_meta_title" />
				</Title>
				<Paragraph>
					<FormattedMessage id="help_meta_description" />
				</Paragraph>
				<List split={false}>
					<List.Item>
						<div>
							✅{' '}
							<Text strong>
								<FormattedMessage id="help_meta_item_1" />
							</Text>
							<Paragraph type="secondary" style={{ margin: 0 }}>
								<FormattedMessage id="help_meta_item_1_description" />
							</Paragraph>
						</div>
					</List.Item>
					<List.Item>
						<div>
							✅{' '}
							<Text strong>
								<FormattedMessage id="help_meta_item_2" />
							</Text>
							<Paragraph type="secondary" style={{ margin: 0 }}>
								<FormattedMessage
									id="help_meta_item_2_description"
									values={{
										link: (chunks: React.ReactNode) => (
											<a
												href="https://business.facebook.com/latest/settings/business_info?business_id=1735950417339899"
												target="_blank"
												rel="noopener noreferrer"
											>
												{chunks}
											</a>
										),
									}}
								/>
							</Paragraph>
						</div>
					</List.Item>
					<List.Item>
						<div>
							✅{' '}
							<Text strong>
								<FormattedMessage id="help_meta_item_3" />
							</Text>
							<Paragraph type="secondary" style={{ margin: 0 }}>
								<FormattedMessage
									id="help_meta_item_3_description"
									values={{
										link: (chunks: React.ReactNode) => (
											<a
												href="https://business.facebook.com/billing_hub/accounts?business_id=1735950417339899&placement=standalone&account_type=whatsapp-business-account"
												target="_blank"
												rel="noopener noreferrer"
											>
												{chunks}
											</a>
										),
									}}
								/>
							</Paragraph>
						</div>
					</List.Item>
					<List.Item>
						<div>
							✅{' '}
							<Text strong>
								<FormattedMessage id="help_meta_item_4" />
							</Text>
							<Paragraph type="secondary" style={{ margin: 0 }}>
								<FormattedMessage
									id="help_meta_item_4_description"
									values={{
										link: (chunks: React.ReactNode) => (
											<a
												href="https://business.facebook.com/latest/whatsapp_manager/message_templates?business_id=1735950417339899&tab=message-templates&nav_ref=whatsapp_manager&asset_id=2030816010774954"
												target="_blank"
												rel="noopener noreferrer"
											>
												{chunks}
											</a>
										),
									}}
								/>
							</Paragraph>
						</div>
					</List.Item>
				</List>
				<Paragraph type="secondary">
					<FormattedMessage
						id="help_meta_info"
						values={{
							link: (chunks: React.ReactNode) => (
								<a
									href="https://br24.bitrix24.com.br/~CRS6d"
									target="_blank"
									rel="noopener noreferrer"
								>
									{chunks}
								</a>
							),
						}}
					/>
				</Paragraph>
			</Typography>

			<Checkbox onChange={(e) => setIsChecked(e.target.checked)} style={{ marginTop: 16 }}>
				<FormattedMessage id="help_meta_confirm_checkbox" />
			</Checkbox>

			<div style={{ textAlign: 'right', marginTop: 16 }}>
				<Button onClick={onNext} type="primary" disabled={!isChecked}>
					<FormattedMessage id="help_meta_btn" />
				</Button>
			</div>
		</Card>
	);
};
